<template>
  <div>
    <button class="side-menu-toggle" type="button" @click="toggleMenu" :aria-expanded="open">
      <i :class="open ? 'bi bi-x-lg' : 'bi bi-list'" aria-hidden="true"></i>
      <span class="visually-hidden">Abrir menu lateral</span>
    </button>

    <transition name="side-menu-slide">
      <aside v-if="open" class="side-menu">
        <div class="side-menu-header d-flex justify-content-between align-items-center mb-4">
          <h5 class="mb-0 text-uppercase">Opções</h5>
          <button class="btn btn-sm btn-outline-light" type="button" @click="toggleMenu">
            <i class="bi bi-x-lg"></i>
          </button>
        </div>

        <ul class="list-unstyled mb-4">
          <li class="mb-3">
            <a href="#" class="menu-link" @click.prevent="navigate('rules')">
              <i class="bi bi-journal-richtext me-2"></i>
              Guia de Regras
            </a>
          </li>
          <li class="mb-3">
            <a href="#" class="menu-link" @click.prevent="navigate('books')">
              <i class="bi bi-book me-2"></i>
              Livros
            </a>
          </li>
          <li class="mb-3">
            <a href="#" class="menu-link" @click.prevent="navigate('games')">
              <i class="bi bi-controller me-2"></i>
              Jogos
            </a>
          </li>
          <li class="mb-3">
            <a href="#" class="menu-link" @click.prevent="navigate('store')">
              <i class="bi bi-shop-window me-2"></i>
              Loja
            </a>
          </li>
          <li class="mb-3">
            <a href="#" class="menu-link" @click.prevent="navigate('chat')">
              <i class="bi bi-chat-dots me-2"></i>
              Chat
            </a>
          </li>
          <li class="mb-3">
            <a href="#" class="menu-link" @click.prevent="navigate('membership')">
              <i class="bi bi-gem me-2"></i>
              Seja Membro!
            </a>
          </li>
          <li class="mb-3">
            <a href="#" class="menu-link" @click.prevent="navigate('register')">
              <i class="bi bi-person-plus me-2"></i>
              Cadastro
            </a>
          </li>
          <template v-if="isLoggedIn">
            <li class="mb-3">
              <a href="#" class="menu-link" @click.prevent="navigate('profile')">
                <i class="bi bi-person-gear me-2"></i>
                Perfil
              </a>
            </li>
            <li class="mb-3">
              <a href="#" class="menu-link" @click.prevent="navigate('characterSheets')">
                <i class="bi bi-file-earmark-person me-2"></i>
                Fichas de Personagem
              </a>
            </li>
            <li class="mt-4 pt-3 border-top border-secondary">
              <a href="#" class="menu-link text-danger" @click.prevent="requestLogout">
                <i class="bi bi-door-open me-2"></i>
                Sair
              </a>
            </li>
          </template>
          <li v-else class="text-muted small">
            Faça login para editar o seu perfil.
          </li>
        </ul>

        <p class="text-muted small mb-0">
          Explore e mantenha suas conexões no Mundo das Trevas.
        </p>
      </aside>
    </transition>

    <div v-if="open" class="side-menu-backdrop" @click="toggleMenu"></div>
  </div>
</template>

<script>
export default {
  name: 'RightSideMenu',
  props: {
    isLoggedIn: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      open: false
    }
  },
  methods: {
    toggleMenu() {
      this.open = !this.open
    },
    navigate(target) {
      this.$emit('navigate', target)
      this.open = false
    },
    requestLogout() {
      this.$emit('logout')
      this.open = false
    }
  }
}
</script>

<style scoped>
.side-menu-toggle {
  position: fixed;
  top: 50%;
  right: 1.5rem;
  transform: translateY(-50%);
  background: var(--vampire-red);
  border: none;
  color: #f8f9fa;
  width: 3rem;
  height: 3rem;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 0 20px rgba(139, 0, 0, 0.45);
  z-index: 1050;
  transition: background 0.3s ease, transform 0.3s ease;
}

.side-menu-toggle:hover {
  background: var(--vampire-blood);
  transform: translateY(-50%) scale(1.05);
}

.side-menu {
  position: fixed;
  top: 0;
  right: 0;
  width: 320px;
  max-width: 90vw;
  height: 100vh;
  background: rgba(17, 17, 17, 0.95);
  backdrop-filter: blur(6px);
  color: #f8f9fa;
  padding: 2.5rem 2rem;
  z-index: 1045;
  border-left: 1px solid rgba(218, 165, 32, 0.25);
}

.side-menu-header h5 {
  letter-spacing: 0.1em;
  color: var(--vampire-gold);
}

.menu-link {
  color: #f8f9fa;
  font-weight: 500;
  text-decoration: none;
  padding: 0.5rem 0;
  display: inline-flex;
  align-items: center;
  transition: color 0.2s ease;
}

.menu-link:hover {
  color: var(--vampire-gold);
}

.side-menu-backdrop {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.6);
  z-index: 1040;
}

.side-menu-slide-enter-active,
.side-menu-slide-leave-active {
  transition: transform 0.3s ease;
}

.side-menu-slide-enter-from,
.side-menu-slide-leave-to {
  transform: translateX(100%);
}
</style>
